import { cn } from '@dolcevia/lib/utils';
import { MinusIcon, PlusIcon } from '@radix-ui/react-icons';
import { AccordionItem } from '@szhsin/react-accordion';
import { useTranslations } from 'next-intl';
import type { FaqContentProps } from './faq-types';

export const FaqContent = ({ question, answer }: FaqContentProps) => {
  const t = useTranslations('Faq');
  return (
    <AccordionItem
      header={({ state: { isEnter } }) => {
        return (
          <div className="flex w-full items-center justify-between text-lg font-medium transition-all hover:underline">
            <span className="text-lg hover:underline font-medium flex">
              {/* @ts-ignore */}
              {t(question)}
            </span>
            <PlusIcon
              id="plus-icon"
              className={cn(
                'flex h-4 w-4 shrink-0 text-neutral-500 transition-transform duration-200 dark:text-neutral-400',
                isEnter && 'hidden',
                !isEnter && 'block',
              )}
            />
            <MinusIcon
              id="minus-icon"
              className={cn(
                'flex h-4 w-4 shrink-0 text-neutral-500 transition-transform duration-200 dark:text-neutral-400',
                isEnter && 'block',
                !isEnter && 'hidden',
              )}
            />
          </div>
        );
      }}
      buttonProps={{ className: 'text-lg hover:underline font-medium w-full' }}
      contentProps={{
        className: 'transition-height duration-200 ease-out',
      }}
      className="bg-hello-yellow-100 rounded-lg p-4 text-sm"
    >
      {/* @ts-ignore */}
      <div dangerouslySetInnerHTML={{ __html: t.raw(answer) }} />
    </AccordionItem>
  );
};
